import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Prevention.PreventionCategory_Minimal}
    mutation UpdatePreventionCategory($id: ID!, $title: String!, $description: String) {
        updatePreventionCategory(input: { id: $id, title: $title, description: $description }) {
            errors
            status
            statusCode
            preventionCategory {
                ...PreventionCategory_Minimal
            }
        }
    }
`
